import { render, staticRenderFns } from "./InstanceTypeSelector.vue?vue&type=template&id=6abc283a&"
import script from "./InstanceTypeSelector.vue?vue&type=script&lang=js&"
export * from "./InstanceTypeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports